<template>
  <div>
    <h2 class="text-xl font-bold mb-1">{{ device.name }}</h2>
    <div class="text-lg font-weight-bold mb-1" v-if="total_distance">
      {{$t('distance')}} ≈ {{ total_distance}}km
    </div>
    <div class="d-flex align-items-center justify-content-between text-lg font-weight-bold mb-2">

      <div> {{ tracker_events.length }} {{ $t('events') }}</div>

      <div v-if="tracker_events.length" :title="$t('share')"
              class="d-flex align-items-center share-icon"
              @click="share_events_data">
        <span data-feather="share" class="m-1"></span>
      </div>
    </div>
    <div class="my-2" v-for="(event, index)  in tracker_events" :key="event.datetime">
      <div v-if="shouldShowDateHeader(index)">
        <div class="text-lg font-bold my-2">
          {{ formatDate(event.datetime) }}
        </div>
      </div>
      <TrackerEventElement :element="event"/>
    </div>
    <div class="my-6"></div>
  </div>
</template>
<script>
import * as nvxlib from "@/nvxcommon";
import TrackerEventElement  from "@/components/TrackerEventElement.vue";
const feather = require("feather-icons");

export default {
  name: 'TrackerEvents',
  components: { TrackerEventElement},
  data: function () {
    return {
      tracker_events:[],
      total_distance: 0
    }
  },
  props: {
    device: {
      type: Object,
      required: true
    },
    date_start:{
      type: Object,
      required: true
    },
    date_end:{
      type: Object,
      required: true
    }
  },
  watch:{
    device: {
      handler: function (val, oldVal) {
        this.getTrackerEvents();
      },
    },
    dateRange: {
      handler: function (val, oldVal) {
        this.getTrackerEvents();
      },
    },
  },
  computed: {
    dateRange() {
      return [this.date_start, this.date_end];
    }
  },
  methods: {
    getTrackerEvents() {
      const self = this;
      const ts1 = this.date_start.unix();
      const ts2 = this.date_end.unix();
      nvxlib.getTrackerEvents(this.device, ts1, ts2, function (events) {
        self.tracker_events = events;
        nvxlib.getTrackerDistance(self.device, ts1, ts2, function (distances) {
          console.log("Distances:", distances);
          self.total_distance = Math.round(distances.reduce((sum, item) => sum + item.distance, 0) * 1.15 / 1000 * 10) / 10;
        });
      });

    },
    formatDate(datetime) {
      const date = new Date(datetime);
      return date.toLocaleDateString(undefined, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    formatDateCompact(dateString) {
      const d = new Date(dateString);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}${mm}${dd}`;
    },
    shouldShowDateHeader(index) {
      if (index === 0) return true;
      const currentDate = new Date(this.tracker_events[index].datetime).toDateString();
      const previousDate = new Date(this.tracker_events[index - 1].datetime).toDateString();
      return currentDate !== previousDate;
    },
    isChromeDesktop() {
      const ua = navigator.userAgent.toLowerCase();
      const isChrome = ua.includes('chrome') && !ua.includes('edg') && !ua.includes('opr');
      const isDesktop = !/android|iphone|ipad|mobile/.test(ua);
      return isChrome && isDesktop;
    },
    share_events_data() {
      const headers = ['Device, Date', 'Time', 'Event', 'Details'];
      const rows = this.tracker_events.map(event => {
        const dateObj = new Date(event.datetime);
        const date = dateObj.toLocaleDateString();
        const time = dateObj.toLocaleTimeString();
        const type = event.type || '';
        const details =`"${JSON.stringify(event.content).replace(/"/g, '""')}"`;
        console.log("details", details);
        return [this.device.serial, date, time, type, details];
      });

      const csvContent = [
        headers.join(','),
        ...rows.map(r => r.join(','))
      ].join('\n');

      const blob = new Blob([csvContent], {type: 'text/csv'});

      // Format filename based on date range
      const serial = this.device.serial || 'device';
      const dates = this.tracker_events.map(e => new Date(e.datetime));
      const start = this.formatDateCompact(dates[0]);
      const end = this.formatDateCompact(dates[dates.length - 1]);
      const filename =
          start === end
              ? `${serial}_events_${start}.csv`
              : `${serial}_events_${start}_${end}.csv`;

      // Use download fallback on desktop
      if (this.isChromeDesktop()) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        return
      }

      // If supported (e.g. on mobile), share using navigator.share
      const file = new File([blob], filename, {type: 'text/csv'});
      navigator.share({
        title: 'Event Tracker Export',
        text: 'Here is your event data.',
        files: [file],
      }).catch(err => {
        console.error('Sharing failed:', err);
      });
    }
  },
  mounted() {
    this.getTrackerEvents(events => {
      this.tracker_events = events;
    });
  },
  updated() {
    feather.replace();
  }
}
</script>
<style>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5); /* Light transparency */
  z-index: 10;
  pointer-events: all; /* Prevent clicks */
}

.share-icon {
  cursor: pointer;
  color: black;
  background: none;
  border: none;
}
.share-icon svg {
  stroke: black; /* ensure icon is black */
  width: 20px;
  height: 20px;
}
</style>